class MainMenuController {
  constructor($state, $location, LoansUserDataService) {
    'ngInject';
    this.state = $state;
    this.location = $location;
    this.loansUserDataService = LoansUserDataService;
  }

  senior(link) {
    return (
      link.title === 'LOANS.WAGE_ADVANCE.TITLE' &&
      this.loansUserDataService.getSenior()
    );
  }

  getCssLink(link) {
    return {
      'has-separator': link.hasSeparator,
      'alt-active':
        link.target === this.state.current.name ||
        link.altStates.includes(this.state.current.name) ||
        link.target.includes(this.location.search().from) ||
        link.fromStates.includes(this.location.search().from)
    };
  }
}

export default MainMenuController;



// WEBPACK FOOTER //
// ./client/app/components/mainMenu/mainMenu.controller.js